module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-h1-title@3x-77f58ead7f9000097a6bbd8a1291914b.png";